import React, { FC } from 'react'

//* utils
import { RichTextWrapper } from '../../../../styles/global'
import ImgUtil from '../../../../utils/img.utils'
import { internalLinkHandler, isExternalURL } from '../../../../utils/link.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'

//* components
import Button from '../../button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

type Props = {
  tileData: any
  useCase: string
  formattedTitle: string
}

export const Tile: FC<Props> = ({ useCase, tileData, formattedTitle }) => {
  const linkTarget = isExternalURL(tileData.cta?.externalUrl || '') ? '_blank' : '_self'
  const tileNoLink = tileData.cta === null ? 'Tiles__Card-Nohover' : ''

  const classes =
    tileData.tileUseCase === 'Pricing'
      ? `Tiles__Card-Link Tiles__Card-Link--Pricing ${tileNoLink}`
      : `Tiles__Card-Link ${tileNoLink}`

  const ctaHref = tileData.cta?.internalLink
    ? internalLinkHandler(tileData.cta.internalLink)
    : tileData.cta?.externalUrl

  const cta2Href = tileData.cta2?.internalLink
    ? internalLinkHandler(tileData.cta2.internalLink)
    : tileData.cta2?.externalUrl

  const openNewLink = (event?: React.MouseEvent) => {
    if (event) {
      event.preventDefault() // Stop default anchor behavior
      event.stopPropagation() // Prevent bubbling
    }

    if (!ctaHref) return
    if (linkTarget === '_blank') {
      window.open(ctaHref)
    } else {
      window.location.href = ctaHref
    }
  }

  return (
    <div className={classes}>
      <a
        className="divAnchor"
        href={ctaHref}
        target={ctaHref && isExternalURL(ctaHref) ? '_blank' : '_self'}></a>
      <div className={`Tiles__Item ${tileData.orangeTheme ? 'Tiles__Orange_Theme' : ''}`}>
        {tileData.image.url && (
          <div className="Tiles__Image-Container">
            {useCase === 'Logo' && (
              <>
                <div className="Tiles__Dots--Top"></div>
                <div className="Tiles__Dots--Bottom"></div>
              </>
            )}

            <WrapperImage
              src={ImgUtil.getResizedImageUrl(tileData.image.url, '')}
              alt={tileData.image.altText}
              height={32}
              width={32}
              threshold={650}
            />
          </div>
        )}

        {tileData.title && (
          <div className={tileData.cta ? 'Tiles__Item-Title' : 'Tiles__Item-Title Nohover'}>
            <Typography className="Tiles__Item-Text" type="label">
              {formattedTitle}
            </Typography>

            {tileData.finePrint && (
              <Typography className="Tiles__Item-FinePrint" type="caption">
                {tileData.finePrint}
              </Typography>
            )}
          </div>
        )}

        {tileData.text && !tileData.rtfText && (
          <Typography className="Tiles__Item-Text font__inter" type="bodyXS">
            {tileData.text}
          </Typography>
        )}

        {tileData.rtfText && (
          <RichTextWrapper $type="bodyXS" className="Tiles__Item-RFT-Text font__inter">
            {renderRichText(tileData.rtfText)}
          </RichTextWrapper>
        )}

        {useCase !== 'Logo' &&
          tileData.cta?.text &&
          (tileData.tileUseCase === 'Pricing' ? (
            <Button
              icon={true}
              href={ctaHref}
              text={tileData.cta?.text}
              type="secondary"
              size="small"
              theme={tileData.orangeTheme ? 'dark' : 'light'}
              className="Tiles__CTA1"
              useCase={tileData.tileUseCase}
            />
          ) : (
            <Button
              icon={true}
              href={ctaHref}
              text={tileData.cta?.text}
              type="text-link"
              size="small"
              theme={'light'}
            />
          ))}

        {tileData.orangeTheme && tileData.cta && tileData.cta2 && (
          <Button
            icon={true}
            href={cta2Href}
            text={tileData.cta2?.text}
            type="text-link"
            size="small"
            theme={'dark'}
            className="Tiles__CTA2"
          />
        )}
      </div>
    </div>
  )
}
